import { defineModel, serializable, castings as castTo } from '../model'

class EventCaterings {
    @castTo.model('CodeEntry')
    @serializable()
    type: ApiModel<'CodeEntry'>[]
}

export default defineModel(EventCaterings)
